export const HISTORICAL_WINDOW_DAYS = 90

export function historicalCutoffDate(referenceDate = new Date()) {
  const cutoff = new Date(referenceDate)
  cutoff.setHours(0, 0, 0, 0)
  cutoff.setDate(cutoff.getDate() - HISTORICAL_WINDOW_DAYS)
  return cutoff
}

export function isWithinHistoricalWindow(dateStr, referenceDate = new Date()) {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false
  const [year, month, day] = dateStr.split('-').map(Number)
  const pointDate = new Date(year, month - 1, day)
  return pointDate >= historicalCutoffDate(referenceDate)
}

export function filterHistoricalSeries(series) {
  if (!Array.isArray(series)) return []
  return series.filter((point) => isWithinHistoricalWindow(point?.date))
}

export function formatHistoricalDate(dateStr) {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('-').map(Number)
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

export function filterHistoricalPayload(payload) {
  if (!payload) {
    return { historical_data: [], historical_data_by_persona: [] }
  }

  return {
    historical_data: filterHistoricalSeries(payload.historical_data || []),
    historical_data_by_persona: (payload.historical_data_by_persona || []).map((personaSeries) => ({
      ...personaSeries,
      data: filterHistoricalSeries(personaSeries.data || [])
    }))
  }
}
